<div class="add-live-bid-payment-container">
  <div class="heading-container flex-row flex-justify-space-between flex-align-center">
    <h2 translate="ADD_LIVE_BID_PAYMENT_DIALOG.HEADER" mat-dialog-title></h2>
    <button class="close-button" mat-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <gb-selected-guest-activity-action></gb-selected-guest-activity-action>
    <p translate="ADD_LIVE_BID_PAYMENT_DIALOG.MESSAGE"></p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="gb-flex-button-container flex-grow">
      <button
        mat-stroked-button
        translate="ADD_LIVE_BID_PAYMENT_DIALOG.PAY_LATER_BUTTON"
        [mat-dialog-close]="result.PayLater"
      ></button>
      <button
        mat-raised-button
        translate="ADD_LIVE_BID_PAYMENT_DIALOG.PAY_BUTTON"
        [mat-dialog-close]="result.PayNow"
        color="primary"
      ></button>
    </div>
  </mat-dialog-actions>
</div>
